export const LABELS = {
    Changes: "changes",
    Configuration: "configuration",
    DeviceDetails: "device details",
    Tasks: "tasks"
} as const;
